import { create } from 'zustand';

/**
 * Namen bij ruwe sleutels in het adres, voor het kruimelpad.
 *
 * Gemeten op 27-08-2026: op het productdetail las het kruimelpad
 * "Datakwaliteit / 8710624010003 / Producten / Message-70569ffd-52eb-448d-891d-972efec806b7".
 * Aan die laatste sleutel heeft niemand iets. Het kruimelpad zelf kent alleen het adres, dus het
 * scherm dat de naam wél kent zet hem hier neer, en het kruimelpad leest hem op.
 *
 * Bewust een losse winkel en geen context: het kruimelpad staat in de schil om alle schermen heen,
 * en het scherm dat de naam kent zit dáárbinnen — een context zou de verkeerde kant op moeten
 * stromen.
 */
interface KruimelNamen {
  namen: Record<string, string>;
  /** Onthoud onder welke naam deze sleutel bij een bezoeker bekendstaat. */
  onthoud: (sleutel: string, naam: string) => void;
  /** Alles vergeten — alleen nodig in toetsen. */
  vergeetAlles: () => void;
}

export const useKruimelNamen = create<KruimelNamen>((set) => ({
  namen: {},
  onthoud: (sleutel, naam) =>
    set((stand) =>
      stand.namen[sleutel] === naam ? stand : { namen: { ...stand.namen, [sleutel]: naam } },
    ),
  vergeetAlles: () => set({ namen: {} }),
}));
